// extracted by mini-css-extract-plugin
export default {"checkbox":"styles_checkbox__1zbij","checkmark":"styles_checkmark__NX0Qh","required":"styles_required__ao9JE"};